/**
 * Chargement (design system, Chargement) : rien n'apparaît avant ≈ 300 ms (fc-chargement),
 * puis un squelette, une rotation avec sa phrase ou une barre fine.
 */
import type { CSSProperties } from 'react';
import { cx } from '../outils';

export type ChargementProps =
  | { type: 'rotation'; texte: string; centre?: boolean }
  | { type: 'barre'; etiquette: string }
  | {
      type: 'squelette';
      forme?: 'texte' | 'titre' | 'pastille' | 'case' | 'bouton' | 'chiffre';
      largeur?: string;
      rang?: number;
    };

export function Chargement(props: ChargementProps) {
  if (props.type === 'rotation') {
    return (
      <div className={cx('fc-chargement', props.centre && 'fc-chargement--centre')}>
        <span className="fc-chargement__indicateur" role="status">
          <span className="fc-rotation" aria-hidden="true" />
          {props.texte}
        </span>
      </div>
    );
  }
  if (props.type === 'barre') {
    return (
      <div
        className="fc-chargement fc-chargement__barre"
        role="progressbar"
        aria-label={props.etiquette}
      />
    );
  }
  const style: CSSProperties = {};
  if (props.largeur) (style as Record<string, string>)['--largeur'] = props.largeur;
  if (props.rang !== undefined) (style as Record<string, string>)['--rang'] = String(props.rang);
  return (
    <span
      className={cx(
        'fc-chargement__squelette',
        props.forme && props.forme !== 'texte' && `fc-chargement__squelette--${props.forme}`,
      )}
      style={style}
      aria-hidden="true"
    />
  );
}
